import type { FaireProductEntity } from "../../entity_types/product";

export const p_73pwjtrncd: FaireProductEntity = {
  token: "p_73pwjtrncd",
  type: "product",
  name: "Harvey Moose Esq Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cceb748d56e14820f4bc7d77218da7e21b5ce01e2363f73441ceca5d72c89a9b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53dc53b57435abbd1286edca4e300bff0a85511944f080b10a86b0d5eee8966a.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:27.249Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
